import React from "react";
import { createFileRoute, Navigate } from "@tanstack/react-router";

import { PageLoading } from "#app/components/loading/page-loading";
import { resolveLandingTab, useLastView } from "#app/lib/views/last-view";
import { TEAM_STRIP_TABS } from "#app/lib/hooks/use-view-tab-order";
import { routePath } from "#app/lib/hooks/use-app-navigate";

/**
 * `/team/$teamId` — redirect to the tab the viewer last had open here, else
 * the team's landing tab, Overview. The memory only counts when the strip
 * still shows that tab — a remembered tab the strip does not seat falls
 * through. The memory resolves async, so hold on a spinner until it is in:
 * deciding early would send everyone to the landing tab.
 */
function TeamIndex() {
  const { workspace, teamId } = Route.useParams();
  const scope = React.useMemo(
    () => ({ kind: "team", id: teamId }),
    [teamId],
  );
  const { lastKey, initialLoading } = useLastView(scope);

  if (initialLoading) {
    return (
      <PageLoading delayed />
    );
  }

  const landingTab = resolveLandingTab(TEAM_STRIP_TABS, lastKey, "overview");
  return (
    <Navigate
      to={routePath(`/${workspace}/team/${teamId}/${landingTab}`)}
      replace
    />
  );
}

export const Route = createFileRoute("/(app)/$workspace/team/$teamId/")({
  component: TeamIndex,
});
